// extracted by mini-css-extract-plugin
export default {"OutcomeModalView":"OutcomeModalView_OutcomeModalView__L4m17","OutcomeIcon":"OutcomeModalView_OutcomeIcon__stwpI"};